module.exports = __webpack_public_path__ + "img/印象丽江入口.e0e97456.jpg";